import { Injectable } from '@angular/core';
import { WebsocketCardEventsAggregationService } from '../websocket-card-events-aggregation/websocket-card-events-aggregation.service';
import { HubEventType } from '@dta/shared/models/event.models';

@Injectable()
export class SomeoneIsTypingService extends WebsocketCardEventsAggregationService {
  constructor() {
    super([HubEventType.EventUserTyping]);
  }
}
